import { merge } from 'lodash';
import { logoutUser } from 'reducers/auth/actions';
import store from 'store';

const kituCompassServerBaseUrl = window.env.REACT_APP_AUTH_SERVER_URL;
const authServerBaseUrl = window.env.REACT_APP_SERVER_API_PATH;

const baseOptions = {
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
};

const responseHandler = async response => {
  const responseText = await response.text();
  let responseJSON;
  try {
    responseJSON = JSON.parse(responseText);
  } catch (jsonParseErr) {
    responseJSON = responseText;
  }

  if (!response.ok) {
    const err = new Error();
    err.name = response.statusText;
    err.status = response.status;

    // If the user receives a 401 and is logged in, log the user out.
    const authenticatedUserInfo =
      store.getState()?.auth?.authenticatedUser || {};
    const userIsLoggedIn = Object.prototype.hasOwnProperty.call(
      authenticatedUserInfo,
      'id'
    );
    if (response.status === 401 && userIsLoggedIn) {
      const dispatch = store.dispatch;
      return dispatch(logoutUser(true));
    }

    err.message = responseJSON || 'An unexpected error has occurred';
    throw err;
  }

  return responseJSON;
};

/**
 *
 * @param {string} apiPath - The REACT_APP environment variable pointing to the location of which API this gets redirected to (e.g. monitor, derApi, Compass-server)
 * @param {string} url - The url being reached in the API (e.g. /devices?start=0&limit=100)
 * @param {Object} options - specific request options such as headers
 */
const get = (apiPath, url, options = {}) => {
  let fetchUrl = kituCompassServerBaseUrl;
  if (apiPath === authServerBaseUrl) {
    fetchUrl += url;
  } else {
    fetchUrl += `${apiPath}${url}`;
  }
  let mergedOptions = merge({ ...options, method: 'GET' }, baseOptions);

  return fetch(fetchUrl, mergedOptions).then(response => {
    return responseHandler(response);
  });
};

/**
 *
 * @param {string} apiPath - The REACT_APP environment variable pointing to the location of which API this gets redirected to (e.g. monitor, derApi, Compass-server)
 * @param {string} url - The url being reached in the API (e.g. /devices?start=0&limit=100)
 * @param {Object} payload - the body of the POST request
 * @param {Object} options - specific request options such as headers
 */
const post = (apiPath, url, payload, options = {}) => {
  let fetchUrl = kituCompassServerBaseUrl;
  if (apiPath === authServerBaseUrl) {
    fetchUrl += url;
  } else {
    fetchUrl += `${apiPath}${url}`;
  }
  let mergedOptions = merge(
    {
      ...options,
      body: JSON.stringify(payload),
      method: 'POST'
    },
    baseOptions
  );
  return fetch(fetchUrl, mergedOptions).then(response => {
    return responseHandler(response);
  });
};

/**
 *
 * @param {string} apiPath - The REACT_APP environment variable pointing to the location of which API this gets redirected to (e.g. monitor, derApi, Compass-server)
 * @param {string} url - The url being reached in the API (e.g. /devices?start=0&limit=100)
 * @param {Object} payload - the body of the POST request
 * @param {Object} options - specific request options such as headers
 */
const put = (apiPath, url, payload, options = {}) => {
  let fetchUrl = kituCompassServerBaseUrl;
  if (apiPath === authServerBaseUrl) {
    fetchUrl += url;
  } else {
    fetchUrl += `${apiPath}${url}`;
  }
  let mergedOptions = merge(
    {
      ...options,
      body: JSON.stringify(payload),
      method: 'PUT'
    },
    baseOptions
  );
  return fetch(fetchUrl, mergedOptions).then(response => {
    return responseHandler(response);
  });
};

/**
 *
 * @param {string} apiPath - The REACT_APP environment variable pointing to the location of which API this gets redirected to (e.g. monitor, derApi, Compass-server)
 * @param {string} url - The url being reached in the API (e.g. /devices?start=0&limit=100)
 * @param {Object} payload - the body of the POST request
 * @param {Object} options - specific request options such as headers
 */
const _delete = (apiPath, url, payload, options = {}) => {
  let fetchUrl = kituCompassServerBaseUrl;
  if (apiPath === authServerBaseUrl) {
    fetchUrl += url;
  } else {
    fetchUrl += `${apiPath}${url}`;
  }
  let mergedOptions = merge(
    {
      ...options,
      body: JSON.stringify(payload),
      method: 'DELETE'
    },
    baseOptions
  );
  return fetch(fetchUrl, mergedOptions).then(response => {
    return responseHandler(response);
  });
};

const setAuthToken = token => {
  baseOptions.headers.Authorization = `Bearer ${token}`;
};

const apiClient = {
  get,
  post,
  put,
  delete: _delete,
  setAuthToken
};

export default apiClient;
